import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Upload } from "@faire/web--source/slate/icons/foundation/Upload";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var EditableAvatar = function(param) {
    var image = param.image, onClick = param.onClick, name = param.name, disableEditing = param.disableEditing;
    var handleClick = disableEditing ? undefined : onClick;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(AvatarWrapper, {
                onClick: handleClick,
                "data-test-id": "editable-avatar",
                children: /*#__PURE__*/ _jsx(ClickableAvatar, {
                    disablePointer: !!disableEditing,
                    size: "x-large",
                    image: image,
                    iconData: {
                        position: "topRight",
                        icon: disableEditing ? null : /*#__PURE__*/ _jsx(IconContainer, {
                            "data-test-id": "editable-avatar-upload-icon",
                            $disablePointer: !!disableEditing,
                            onClick: handleClick,
                            children: /*#__PURE__*/ _jsx(UploadIcon, {
                                width: "15",
                                height: "15"
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(TextWrapper, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    align: "center",
                    maxLines: 3,
                    children: name
                })
            })
        ]
    });
};
var Container = styled(Column).withConfig({
    componentId: "sc-6beba7ce-0"
})([
    "max-width:166px;padding-left:",
    ";padding-right:",
    ";"
], getSpacing("2x"), getSpacing("2x"));
var AvatarWrapper = styled.div.withConfig({
    componentId: "sc-6beba7ce-1"
})([
    "margin-left:auto;margin-right:auto;"
]);
var TextWrapper = styled.div.withConfig({
    componentId: "sc-6beba7ce-2"
})([
    "max-width:140px;"
]);
var UploadIcon = styled(Upload).withConfig({
    componentId: "sc-6beba7ce-3"
})([
    "margin:auto;"
]);
var ClickableAvatar = styled(Avatar).withConfig({
    componentId: "sc-6beba7ce-4"
})([
    "cursor:",
    ";border-left:1px solid ",
    ";border-bottom:1px solid ",
    ";border-top:1px solid ",
    ";"
], function(param) {
    var disablePointer = param.disablePointer;
    return disablePointer ? "default" : "pointer";
}, Core.surface.subdued, Core.surface.subdued, Core.surface.subdued);
var IconContainer = styled.div.withConfig({
    componentId: "sc-6beba7ce-5"
})([
    "background-color:",
    ";width:24px;height:24px;border-radius:50%;display:flex;cursor:",
    ";"
], Core.surface.subdued, function(param) {
    var $disablePointer = param.$disablePointer;
    return $disablePointer ? "default" : "pointer";
});
